import styled, { css } from "styled-components";
import { device } from "../../styles/mediaQueries";

export const Wrapper = styled.main`
  ${({ theme }) => css`
    margin: 0 0.7rem;
    padding-bottom: ${theme.spacings.medium};
    height: 100vh;
    display: flex;
    flex-direction: column;

    @media (${device.tablet}) {
      max-width: 1080px;
      padding: 20px 0.7rem;
      margin: auto;
    }
  `}
`;
